import React, { useState, useEffect } from 'react';
import apiClient from '../../../api/apiClient';
import { publish, subscribe, unsubscribe } from '../../../utils/pubsubWrapper';
import { Form, InputGroup, Row, Col, Spinner, Button } from 'react-bootstrap';
import { scrollToTop,isMobileDevice } from '../../../utils/utils';
import { CourseCard, AlertMassage, PopupModel, Intersect, AddReviewRating } from '../../shared';
import { useNavigate } from 'react-router-dom';
import { useLogin } from '../../../context/LoginContext';
import { GETCOURSELIST } from '../../../utils/ApiEndPoint';
import { useCourse } from '../../../context/CourseContext';

const CourseList = ({ showcourse = 'all', title = '', courselearningstatus = 'all' }) => {
  const { user } = useLogin();
  const { userCourse, fetchAllCourse, getCourseProgerss, addreviewRatting, HandelAddreviewRatting, saveReviewRating } = useCourse();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [showAlert, setShowAlert] = useState({
    type: '',
    title: '',
    msg: ``,
    show: false
  });
  const [popupData, setPopupData] = useState({
    show: false,
    title: '',
    type: '',
    selectedItem: {},
  });

  const totalCoursesToShow = user?.selectedRole === 'viewer' ? 3 : 4;
  const [visibleCount, setVisibleCount] = useState(totalCoursesToShow);

  useEffect(() => {
    user?.selectedRole === 'viewer' && getCourseProgerss(userCourse);
  }, [user?.selectedRole]);
  useEffect(() => {
    const pubsubToken = subscribe('FETCH_COURSE', () => {
      fetchAllCourse();
    });
    return () => unsubscribe(pubsubToken);
  }, []);
  // useEffect(() => {
  //   setAllowHover(!isMobileDevice());
  // }, [setAllowHover,isMobileDevice]);
  useEffect(() => {
    setVisibleCount(totalCoursesToShow);
  }, [userCourse]);
  const handleCloseModal = () => {
    setPopupData({
      show: false,
      title: '',
      type: '',
      selectedItem: {},
    })
  };
  const handlelSaveRating = (rating, review) => {
    // console.log("🚀 krishna  ~ rating, review:", rating, review, addreviewRatting?.courseId);

    const saveresponse = saveReviewRating(rating, addreviewRatting?.courseId, review);
    // console.log("🚀 krishna  ~ saveresponse:", saveresponse);

    setShowAlert({
      type: saveresponse.success ? 'success' : 'danger',
      title: saveresponse.success ? 'Success' : 'Error',
      msg: saveresponse.success ? `Your review and rating is submitted successfully` : saveresponse.message || `Failed to submit your review and rating`,
      show: true
    })
  }
  const handelAction = async (e, actionType, item) => {
    switch (actionType) {
      case 'edit':
        publish('EDIT_COURSE', item);
        scrollToTop();
        break;
      case 'delete':
        setPopupData({
          show: true,
          title: 'Confirm!',
          type: 'confirm',
          selectedItem: item,
        })
        break;
      case 'view':
        navigate(`/viewcourses/${item?._id}`);
        scrollToTop();
        break;
    }
  }

  const handelDelete = async () => {
    const data = {
      "deletedBy": popupData?.selectedItem?.createdBy,
    }
    const title = popupData?.selectedItem?.title || 'no title';
    const id = popupData?.selectedItem?._id;
    let tempAlert = {
      type: 'danger',
      title: 'Error',
      msg: '',
      show: true
    }
    apiClient.delete(`${GETCOURSELIST}/${id}`, data)
      .then((response) => {
        if (response.status === 200) {
          fetchAllCourse();
          tempAlert.type = 'success';
          tempAlert.title = 'Success';
          tempAlert.msg = `${title} is deleted successfully`;
          setShowAlert(tempAlert)
        } else {
          tempAlert.msg = `Failed to delete ${title} videos`;
          setShowAlert(tempAlert);
        }
      }).catch((error) => {
        tempAlert.msg = `Failed to delete ${title} videos`;
        setShowAlert(tempAlert);
      }).finally(() => {
        handleCloseModal();
      });
  }
  const hideAlert = () => {
    setShowAlert({
      type: '',
      title: '',
      msg: '',
      show: false
    })
  }
  const courseStatusFilter = userCourse.filter(course => {
    if (showcourse === 'all') {
      return true;
    } else if (showcourse === 'published') {
      return course.status === 'published';
    }
  });
  const courseLearningStatusFilter = courseStatusFilter.filter(course => {
    if (courselearningstatus === 'all') {
      return true;
    } else if (courselearningstatus === 'inprogress') {
      return course.progressPercent < 100 && course.progressPercent > 0;
    } else if (courselearningstatus === 'completed') {
      return course.progressPercent === 100;
    }
  });
  const filteredCourese = courseLearningStatusFilter.filter(course => {
    const searchLower = search.toLowerCase();
    return (
      course?.title?.toLowerCase().includes(searchLower) ||
      (Array.isArray(course.tags) ? course.tags?.join(' ').toLowerCase() : '').includes(searchLower)
    );
  });

  return (
    <>
      <Row style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <Col md={6} xs={12}>
          <h6 className='pt-4' style={{ 'fontSize': '1.25rem' }}>{title}</h6>
        </Col>
        <Col md={4} xs={12} className='p-relative mt-3'>
          <InputGroup>
            <Form.Control
              placeholder="Search courses..."
              type='search'
              value={search}
              onChange={e => setSearch(e.target.value)}
              className='searchbox-input'
              style={{ height: '40px' }}
            />
          </InputGroup>
          <span className='search-icon2'></span>
        </Col>
      </Row>
      <Row className='mt-4 position-relative'>
        {filteredCourese.length === 0 ? (
          <Col lg={12} className='text-center'>
            <p >No Course Found</p>
          </Col>
        ) : filteredCourese.slice(0, visibleCount).map((course, idx, arr) => {
          const isLast = idx === arr.length - 1;
          return (
            <React.Fragment key={course._id}>
              <Col lg={user?.selectedRole == 'viewer' ? 4 : 3} md={user?.selectedRole == 'viewer' ? 6 : 6} sm={user?.selectedRole == 'viewer' ? 6 : 6} className='course-card'>
                <CourseCard course={course} handelAction={handelAction}/>
              </Col>
              {isLast && filteredCourese.length > visibleCount && (
                <Col md={12} className='p-2'>
                  <Intersect
                    onIntersect={() => setVisibleCount(c => Math.min(c + totalCoursesToShow, filteredCourese.length))}
                    disabled={visibleCount >= filteredCourese.length}
                  >
                  </Intersect>
                </Col>
              )}
            </React.Fragment>
          )
        })
        }
      </Row>
      {popupData.show && popupData.type === 'confirm' ?
        <PopupModel
          size='md'
          showModal={popupData.show}
          handleCloseModal={handleCloseModal}
          title={popupData.title}
          type={popupData.type}
          footerContent={
            <>
              <Button variant="danger" onClick={handelDelete}>Yes</Button>
              <Button variant="info" onClick={handleCloseModal}>No</Button>
            </>
          }
        >
          <p>Are you sure you want to delete <strong>{popupData.selectedItem?.title}</strong> ? This action cannot be undone.</p>
        </PopupModel> : null}
      {showAlert.show &&
        <AlertMassage
          show={showAlert.show}
          type={showAlert.type}
          title={showAlert.title}
          massage={showAlert.msg}
          hideAlert={hideAlert} />
      }
      {addreviewRatting.status &&
        <PopupModel
          size='md'
          showModal={addreviewRatting.status}
          handleCloseModal={HandelAddreviewRatting.bind(this, false, '', 0, '')}
          title={`Review & Rating`}
          type={'info'}
        >
          <AddReviewRating courseTitle={addreviewRatting.coursetitle} onHandelSave={handlelSaveRating} ratingValue={addreviewRatting.rating} reviewValue='' />
        </PopupModel>
      }
    </>
  );
};

export default CourseList;